import React, { useEffect, useState, useRef, useMemo } from "react";
import Footer from "../../../components/home_page/Footer";
import "./daybook.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  contraVoucherList,
  voucherEntryDelete,
  saveDaybookState,
} from "../../../redux/actions/action-creator";
import { toast } from "react-toastify";
import Modal from "react-modal";
import {
  dateFormateShow,
  dateFormateSend,
  getVoucherDate,
  getValidPeriodDate,
} from "../../../components/Date_Formate_Utilitiy/Index";
import DeletConfirm from "../../../components/Modal/DeletConfirm";
import Indicator from "../../../components/Indicator/Indicator";
import { usePermission } from "../../../hooks/usePermission";
import HomeLayout from "../../../components/home_page/HomeLayout";

function DayBook() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { company_session, daybook_persisted_state } = useSelector((state) => state.common);
  const { userData } = useSelector((state) => state.auth);

  const { view } = usePermission('Reports', 'DayBook');

  const date_formated_send = dateFormateSend(company_session?.current_date);
  const date_formated_show = dateFormateShow(company_session?.current_date);


  const shouldReset = location.state?.resetId && location.state.resetId !== daybook_persisted_state?.lastResetId;

  const [date, setDate] = useState(shouldReset ? date_formated_show : (daybook_persisted_state?.date || date_formated_show));
  const [send_date, setsend_date] = useState(shouldReset ? {
    from_date: date_formated_send,
    to_date: "",
  } : (daybook_persisted_state?.send_date || {
    from_date: date_formated_send,
    to_date: "",
  }));
  const [state_configure, setState_configure] = useState({
    show_narrations: "No",
    formate_of_report: "Condensed",
    show_bill_wise_details: "No",
    show_inventory_details: "No",
    show_mode_of_payment: "No",
    show_additional_bank_details: "No",
    display_name_for_ledgers: "Name Only",
    display_name_for_stock_items: "Name Only",
    sorting_method: "Default",
    show_running_balance: "Yes",
  });
  const boxRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [record, setrecord] = useState(false);
  const [loading, setLoading] = useState(true);
  const [show_period, setshow_period] = useState(false);
  const [show_configure, setshow_configure] = useState(false);
  const [show_period_double, setshow_period_double] = useState(false);
  const [show_other_voucher, setshow_other_voucher] = useState(false);
  const [all_data, setall_data] = useState([]);
  const [removedItems, setRemovedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(shouldReset ? 0 : (daybook_persisted_state?.selectedItem ?? 0));
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [voucherFilter, setVoucherFilter] = useState(shouldReset ? "" : (daybook_persisted_state?.voucherFilter || ""));

  const displayNameOfVoucherType = (name) => {
    setVoucherFilter(name === voucherFilter ? "" : name);
    setSelectedItem(0);
    setshow_other_voucher(false);
  };

  useEffect(() => {
    dispatch(saveDaybookState({
      date,
      send_date,
      selectedItem,
      voucherFilter,
      lastResetId: location.state?.resetId || daybook_persisted_state?.lastResetId
    }));
  }, [date, send_date, selectedItem, voucherFilter, dispatch, location.state?.resetId]);
  useEffect(() => {
    setIsLoading(true);
    let formdata = new FormData();
    formdata.append("fromDate", send_date?.from_date);
    formdata.append("toDate", send_date?.to_date);
    formdata.append("company_id", userData?.id);

    dispatch(contraVoucherList(formdata))
      .then((response) => {
        if (response?.status) {
          const voucherList = response?.data?.voucherEntryList;
          if (voucherList && voucherList.length > 0) {
            const processedList = voucherList.map(item => {
              const safeParse = (val) => {
                if (!val) return [];
                if (Array.isArray(val)) return val;
                if (typeof val !== 'string') return [];
                try { return JSON.parse(val); } catch (e) { return []; }
              };

              const particular_ledger_pos = safeParse(item.particular_ledger_pos);
              const voucher_item_data = safeParse(particular_ledger_pos[0]?.voucher_item_data);
              const sale_purchase_item_ledger = safeParse(particular_ledger_pos[0]?.sale_purchase_item_ledger);
              const payment_allocation_data = safeParse(particular_ledger_pos[0]?.payment_allocation_data);

              const isSalesPurchase = item?.voucher_type?.toLowerCase().includes('sale') ||
                item?.voucher_type?.toLowerCase().includes('purchase') ||
                item?.voucher_type?.toLowerCase().includes('debit note') ||
                item?.voucher_type?.toLowerCase().includes('credit note');

              let netTotal = parseFloat(String(item.voucher_amount || 0).replace(/,/g, "")) || 0;
              let party_to_pay_amount = 0;
              if (isSalesPurchase) {
                const itemTotal = voucher_item_data.reduce((acc, it) => acc + (parseFloat(String(it.item_amt || 0).replace(/,/g, "")) || 0), 0);
                const ledgerTotal = sale_purchase_item_ledger.reduce((acc, sl) => acc + (parseFloat(String(sl.ledger_amt || 0).replace(/,/g, "")) || 0), 0);
                const paymentTotal = payment_allocation_data.reduce((acc, pa) => acc + (parseFloat(String(pa.payment_ledger_amount || 0).replace(/,/g, "")) || 0), 0);
                netTotal = itemTotal + ledgerTotal;
                party_to_pay_amount = itemTotal + ledgerTotal - paymentTotal;
              }

              // Robust party name resolution
              const resolvedPartyName = item?.party_bill_to_ledger_name || item?.ledger_name ||
                (particular_ledger_pos?.[0]?.particular_ledger_name) || "";

              return {
                ...item,
                particular_ledger_pos,
                voucher_item_data,
                sale_purchase_item_ledger,
                payment_allocation_data,
                voucher_amount: netTotal,
                party_to_pay_amount: party_to_pay_amount,
                party_bill_to_ledger_name: resolvedPartyName
              };
            });
            setall_data(processedList);
            setrecord(false);
          } else {
            setall_data([]);
            setrecord(true);
          }
        } else {
          // Handle unsuccessful response
          setall_data([]);
          setrecord(true);
          toast.error(response?.message || "Failed to fetch voucher list", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((error) => {
        // Handle error case
        setall_data([]);
        setrecord(true);
        console.error("Error fetching voucher data:", error);
        toast.error(error?.message || "Failed to fetch voucher list", {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .finally(() => {
        setLoading(false);
        setIsLoading(false);
      });
  }, [send_date, date, refreshKey]);

  useEffect(() => {
    if (all_data.length > 0 && daybook_persisted_state?.selectedItem === undefined) {
      setSelectedItem(all_data.length - 1);
    }
  }, [all_data.length]);

  // Redundant save effect removed as it is consolidated above

  const filteredData = all_data.filter((item) =>
    voucherFilter ? item?.voucher_type_name === voucherFilter : true
  );

  const totals = useMemo(() => {
    return filteredData.reduce(
      (acc, item) => {
        if (item?.type === "DR") {
          acc.debit += Number(item?.voucher_amount || 0);
        } else if (item?.type === "CR") {
          acc.credit += Number(item?.voucher_amount || 0);
        }
        return acc;
      },
      { debit: 0, credit: 0 }
    );
  }, [filteredData]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (show_period || show_period_double || show_configure || show_other_voucher || isDeleteModalOpen) {
      } else {
        if (e.key === "ArrowUp") {
          e.preventDefault();
          setSelectedItem((prevState) => Math.max(prevState - 1, 0));
        } else if (e.key === "ArrowDown") {
          e.preventDefault();
          setSelectedItem((prevState) =>
            Math.min(prevState + 1, filteredData.length - 1)
          );
        } else if (e.key === "Home") {
          e.preventDefault();
          setSelectedItem(0);
        } else if (e.key === "End") {
          e.preventDefault();
          setSelectedItem(filteredData.length - 1);
        }
        if (e.key === "Enter" && e.ctrlKey) {
          e.preventDefault();
          const selectedList = filteredData[selectedItem];
          if (selectedList) {
            const navId = (selectedList?.uid && selectedList?.uid !== 0 && selectedList?.uid !== "0")
              ? selectedList.uid
              : (selectedList?.voucher_entries_id || selectedList?.id);
            navigate(`../voucher-transaction-alter/${navId}`);
          }
        } else if (e.key === "Enter") {
          e.preventDefault();
          const selectedList = filteredData[selectedItem];
          if (selectedList) {
            const navId = (selectedList?.uid && selectedList?.uid !== 0 && selectedList?.uid !== "0")
              ? selectedList.uid
              : (selectedList?.voucher_entries_id || selectedList?.id);
            navigate(`../voucher-transaction-view/${navId}`);
          }
        } else if (e.altKey && (e.key === "a" || e.key === "A")) {
          e.preventDefault();
          const selectedList = filteredData[selectedItem];
          if (selectedList) {
            navigate(`../voucherstransaction`, {
              state: {
                create_date: dateFormateShow(selectedList?.create_date),
                voucher_type_id: selectedList?.voucher_type_id,
                voucher_type_name: selectedList?.voucher_type_name
              }
            });
          } else {
            navigate(`../voucherstransaction`);
          }
        } else if (e.altKey && e.key === "2") {
          e.preventDefault();
          const selectedList = filteredData[selectedItem];
          if (selectedList) {
            const navId = (selectedList?.uid && selectedList?.uid !== 0 && selectedList?.uid !== "0")
              ? selectedList.uid
              : (selectedList?.voucher_entries_id || selectedList?.id);
            navigate(`../voucher-transaction/${navId}`);
          }
        } else if (e.altKey && (e.key === "d" || e.key === "D")) {
          e.preventDefault();
          if (selectedItems.length > 0 || filteredData[selectedItem]) {
            setIsDeleteModalOpen(true);
          }
        } else if (e.altKey && (e.key === "r" || e.key === "R")) {
          e.preventDefault();
          if (selectedItems.length > 0 || filteredData[selectedItem]) {
            removeSelectedItems();
          }
        } else if (e.altKey && (e.key === "u" || e.key === "U")) {
          e.preventDefault();
          if (removedItems.length > 0) {
            restoreSelectedItems();
          }
        } else if (e.key === " ") {
          // Handling space key press for selecting items
          e.preventDefault();
          toggleSelection(selectedItem);
        } else if (
          e.key.length === 1 &&
          !e.ctrlKey &&
          !e.altKey &&
          !e.metaKey &&
          /[a-zA-Z]/.test(e.key)
        ) {
          // Alpha Jump: jump to next row whose Particular text starts with the pressed letter
          e.preventDefault();
          const char = e.key.toLowerCase();
          const startIndex = (selectedItem + 1) % filteredData.length;

          const getParticularText = (item) => {
            const isSalesPurchase =
              item?.voucher_type?.toLowerCase().includes('sale') ||
              item?.voucher_type?.toLowerCase().includes('purchase') ||
              item?.voucher_type?.toLowerCase().includes('debit note') ||
              item?.voucher_type?.toLowerCase().includes('credit note');
            if (isSalesPurchase) {
              return item?.particular_ledger_pos?.[0]?.party_bill_to_ledger_name || '';
            }
            return item?.particular_ledger_pos?.[1]?.particular_ledger_name || '';
          };

          let nextIndex = -1;
          for (let i = 0; i < filteredData.length; i++) {
            const idx = (startIndex + i) % filteredData.length;
            const label = getParticularText(filteredData[idx]);
            if (label.trim().toLowerCase().startsWith(char)) {
              nextIndex = idx;
              break;
            }
          }
          if (nextIndex !== -1) {
            setSelectedItem(nextIndex);
          }
        }
      }
    };

    const handleWheel = (e) => {
      if (show_period || show_period_double || show_configure || show_other_voucher || isDeleteModalOpen) {
      } else {
        e.preventDefault();
        if (e.deltaY < 0) {
          setSelectedItem((prevState) => Math.max(prevState - 1, 0));
        } else if (e.deltaY > 0) {
          setSelectedItem((prevState) =>
            Math.min(prevState + 1, filteredData.length - 1)
          );
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [
    selectedItem,
    selectedItems,
    removedItems,
    filteredData,
    show_period,
    date,
    show_period_double,
    show_configure,
    show_other_voucher,
    isDeleteModalOpen,
    all_data,
    voucherFilter,
  ]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (show_other_voucher || show_period || show_period_double) {
      } else {
        if (e.altKey && (e.key === "F1")) {
          e.preventDefault();
          setState_configure((prev) => ({
            ...prev,
            formate_of_report:
              prev.formate_of_report === "Detailed" ? "Condensed" : "Detailed",
          }));
        }
        if (e.key === "F2") {
          e.preventDefault();
          setshow_period(true);
        }
        if (e.altKey && e.key === "F2") {
          e.preventDefault();
          setshow_period_double(true);
          setshow_period(false);
        }
        if (e.key === "F4") {
          e.preventDefault();
          setshow_other_voucher(true);
        }
        if (e.key === "F12") {
          e.preventDefault();
          setshow_configure(true);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show_period, show_other_voucher, show_period_double, show_configure]);

  // scroll functionality ---------------------------
  useEffect(() => {
    if (boxRef.current) {
      // setClick(parseInt((boxRef.current.scrollHeight - boxRef.current.offsetHeight - boxRef.current.scrollTop) / 19))
      const selectedElement = boxRef.current.querySelector(".selected");
      if (selectedElement) {
        const boxHeight = boxRef.current.offsetHeight;
        const elementBottom = selectedElement.offsetTop + 70;
        const elementBottom1 =
          selectedElement.offsetTop + selectedElement.offsetHeight + 70;
        if (elementBottom > boxHeight) {
          // setClick(parseInt((boxRef.current.scrollHeight - boxRef.current.offsetHeight - boxRef.current.scrollTop) / 20))
          boxRef.current.scrollTop = elementBottom - boxHeight;
        } else {
          if (elementBottom1 > boxHeight) {
            boxRef.current.scrollTop = elementBottom - boxHeight;
          }
        }
      }
    }
  }, [selectedItem]);
  // Function to toggle selection of an item
  const toggleSelection = (index) => {
    setSelectedItems((prevSelected) => {
      const selectedIndex = prevSelected.indexOf(index);
      if (selectedIndex === -1) {
        return [...prevSelected, index];
      } else {
        return prevSelected.filter((i) => i !== index);
      }
    });
  };
  // Function to remove selected items
  const removeSelectedItems = () => {
    // Map selected indices (from filteredData) to items and find their original positions in all_data
    let itemsToRemoveIndices = [];
    if (selectedItems.length > 0) {
      itemsToRemoveIndices = selectedItems;
    } else if (selectedItem !== -1 && filteredData[selectedItem]) {
      itemsToRemoveIndices = [selectedItem];
    }

    const itemsToRemove = itemsToRemoveIndices.map(index => {
      const item = filteredData[index];
      const originalIndex = all_data.indexOf(item);
      return { index: originalIndex, item };
    }).sort((a, b) => a.index - b.index);

    if (itemsToRemove.length === 0) return;

    // Filter out these items from all_data
    const updatedData = all_data.filter(item => !itemsToRemove.some(r => r.item === item));
    setall_data(updatedData);

    // Store the group of items removed as a single undo step
    setRemovedItems(prev => [...prev, itemsToRemove]);
    setSelectedItems([]);
  };

  // Function to restore selected items
  const restoreSelectedItems = () => {
    if (removedItems.length === 0) return;

    const lastRemovedGroup = removedItems[removedItems.length - 1];

    // Create a copy of all_data to perform insertions
    let updatedData = [...all_data];

    // Sort group by original index to ensure correct sequential insertion
    const sortedGroup = [...lastRemovedGroup].sort((a, b) => a.index - b.index);

    sortedGroup.forEach(removed => {
      updatedData.splice(removed.index, 0, removed.item);
    });

    setall_data(updatedData);
    setRemovedItems(prev => prev.slice(0, -1));
  };
  const formatCurrency = (number) => {
    const [wholePart, decimalPart] = Number(number).toFixed(2).split(".");
    const formattedWholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formattedWholePart}.${decimalPart}`;
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isDeleteModalOpen) {
        if (e.key === "a" && e.ctrlKey) {
          e.preventDefault();
          yPressToDelete();
        }
        if (e.key === "y" || e.key === "Y") {
          e.preventDefault();
          yPressToDelete();
        }
        if (e.key === "n" || e.key === "N") {
          e.preventDefault();
          setIsDeleteModalOpen(false);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDeleteModalOpen, selectedItems, selectedItem, filteredData, userData, loading]);

  //Triggered when a press ok in modal to delete uqc code -----------------------------------------------------------------------------------------
  const yPressToDelete = () => {
    setLoading(true);
    const promises = [];
    const deleteMessages = { success: [], failure: [] };
    if (selectedItems.length > 0) {
      const uidsArray = selectedItems.map((selectedIndex) => {
        const item = filteredData[selectedIndex];
        // Priority: non-zero uid > non-zero voucher_entries_id > id
        return (item?.uid && item?.uid !== 0 && item?.uid !== "0")
          ? item.uid
          : (item?.voucher_entries_id && item?.voucher_entries_id !== 0 && item?.voucher_entries_id !== "0")
            ? item.voucher_entries_id
            : item?.id;
      });
      const uidsString = uidsArray.filter(id => id).join(",");
      if (!uidsString) {
        toast.error("No valid voucher ID found for deletion");
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("uid", uidsString);
      formData.append("id", uidsString);
      formData.append("company_id", userData?.id);

      // Add voucher type info if available (from the first selected item)
      if (selectedItems.length > 0) {
        const firstItem = filteredData[selectedItems[0]];
        if (firstItem?.voucher_type_id) formData.append("voucher_type_id", firstItem.voucher_type_id);
        if (firstItem?.voucher_type_name) formData.append("voucher_type_name", firstItem.voucher_type_name);
      }

      //console.log("FormData Contents:", Object.fromEntries(formData.entries()));

      const deletePromise = dispatch(voucherEntryDelete(formData));
      promises.push(deletePromise);
    } else {
      const item = filteredData[selectedItem];
      const deleteId = (item?.uid && item?.uid !== 0 && item?.uid !== "0")
        ? item.uid
        : (item?.voucher_entries_id && item?.voucher_entries_id !== 0 && item?.voucher_entries_id !== "0")
          ? item.voucher_entries_id
          : item?.id;

      if (!deleteId) {
        toast.error("No valid voucher ID found for deletion");
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("uid", deleteId);
      formData.append("id", deleteId);
      formData.append("company_id", userData?.id);
      if (item?.voucher_type_id) formData.append("voucher_type_id", item.voucher_type_id);
      if (item?.voucher_type_name) formData.append("voucher_type_name", item.voucher_type_name);

      console.log("FormData Contents:", Object.fromEntries(formData.entries()));

      const deletePromise = dispatch(voucherEntryDelete(formData));
      promises.push(deletePromise);
    }
    Promise.all(promises)
      .then((responses) => {
        responses.forEach((response, index) => {
          if (response.status) {
            deleteMessages.success.push(
              response?.message || "Group delete successfully!"
            );
          } else {
            deleteMessages.failure.push(response?.message || "Fail!");
          }
        });
        if (deleteMessages.success.length > 0) {
          setSelectedItems([]);
          toast.success(deleteMessages.success.join("\n"), {
            position: toast.POSITION.TOP_CENTER,
          });
          setRefreshKey((prev) => prev + 1);
        }
        if (deleteMessages.failure.length > 0) {
          toast.warn(deleteMessages.failure.join("\n"), {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setIsDeleteModalOpen(false);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error:", error);
        toast.error(error?.message || "Failed!", {
          position: toast.POSITION.TOP_CENTER,
        });
        setIsDeleteModalOpen(false);
        setLoading(false);
      });
  };

  if (!view) {
    return (
      <HomeLayout>
        <div className="d-flex justify-content-center align-items-center h-100">
          <h3>You do not have permission to access this page.</h3>
        </div>
      </HomeLayout>
    );
  }

  return (
    <div className="section">
      <div className="detail">
        {isDeleteModalOpen ? (
          <div style={{ zIndex: 10000 }}>
            <DeletConfirm
              handleSubmit={yPressToDelete}
              loading={loading}
              closeModal={() => setIsDeleteModalOpen(false)}
            />
          </div>
        ) : null}
        {show_period ? (
          <Period
            date={date}
            setall_data={setall_data}
            setrecord={setrecord}
            setDate={setDate}
            setsend_date={setsend_date}
            setshow_period={setshow_period}
            show_period={show_period}
            setLoading={setLoading}
          />
        ) : null}
        {show_period_double ? (
          <PeriodDouble
            date={date}
            send_date={send_date}
            setall_data={setall_data}
            setrecord={setrecord}
            setDate={setDate}
            setsend_date={setsend_date}
            setshow_period_double={setshow_period_double}
            show_period_double={show_period_double}
            setLoading={setLoading}
          />

        ) : null}
        {show_other_voucher ? (
          <OtherVoucher
            setshow_other_voucher={setshow_other_voucher}
            show_other_voucher={show_other_voucher}
            displayNameOfVoucherType={displayNameOfVoucherType}
          />
        ) : null}
        {show_configure ? (
          <Configure
            setshow_configure={setshow_configure}
            show_configure={show_configure}
            setState_configure={setState_configure}
          />
        ) : null}
        <div className="container-fluid">
          <div className="row table_date_header">
            <div className="col-12  d-flex justify-content-between  table_header_font">
              <b>DayBook </b>
              <span>
                {typeof date === "string"
                  ? date
                  : `${date?.from_date} To ${date?.to}`}
              </span>
            </div>
          </div>

          <div className="row border_2_2px_bottom mt-0">
            <div
              className="col-1 px-1 font-weight-bold font_size"
              style={{ width: "8%", textAlign: "right" }}
            >
              Date
            </div>
            <div
              className="col-5 px-1 font-weight-bold font_size"
              style={{ width: "44%", textAlign: "left" }}
            >
              Particular
            </div>
            <div
              className="col-1 px-1  font-weight-bold  font_size"
              style={{ width: "15%", textAlign: "left" }}
            >
              Vch Type
            </div>
            <div
              className="col-1 px-1  font-weight-bold font_size "
              style={{ width: "12%", textAlign: "right" }}
            >
              Vch No.
            </div>
            <div
              className="col-2 px-1 font-weight-bold font_size "
              style={{ width: "10%", textAlign: "right" }}
            >
              Debit Amount
            </div>
            <div
              className="col-2 px-1 font-weight-bold font_size "
              style={{ width: "10%", textAlign: "right" }}
            >
              Credit Amount
            </div>
          </div>
          {isLoading ? (
            <div className="row">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <Indicator />
              </div>
            </div>
          ) : (
            <>
              <div
                className="row"
                style={{
                  height: "76.9vh",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
                ref={boxRef}
              >
                {record ? (
                  <div className="col-12 d-flex align-items-center justify-content-center">
                    <p className="text-muted">No Record Found !...</p>
                  </div>
                ) : (
                  <div className="col-12 m-0 p-0" style={{ height: 20 }}>
                    {filteredData
                      ?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={
                              selectedItems.includes(index)
                                ? "selected_multi"
                                : ""
                            }
                          >
                            <div
                              className={`row m-0 ${index === selectedItem
                                ? selectedItems.includes(index)
                                  ? "selected_multi_selected"
                                  : "selected"
                                : ""
                                }`}
                              onClick={(e) => {
                                e.preventDefault();
                                //toggleSelection(index);
                                setSelectedItem(index);
                              }}
                              onDoubleClick={(e) => {
                                e.preventDefault();
                                navigate(`../voucher-transaction-view/${item?.uid}`);
                              }}
                            >
                              <div
                                className="col-1 px-1"
                                style={{
                                  width: "8%",
                                  textAlign: "right",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {dateFormateShow(item?.create_date)}
                              </div>
                              <div
                                className="col-5 px-1"
                                style={{
                                  width: "44%",
                                  textAlign: "left",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {state_configure?.formate_of_report === "Condensed"
                                  ? (
                                    item?.voucher_type.toLowerCase().includes('sale') ||
                                    item?.voucher_type.toLowerCase().includes('purchase') ||
                                    item?.voucher_type.toLowerCase().includes('debit note') ||
                                    item?.voucher_type.toLowerCase().includes('credit note')
                                  )
                                    ? item?.particular_ledger_pos?.[0]?.party_bill_to_ledger_name
                                    : item?.particular_ledger_pos?.[1]?.particular_ledger_name
                                  : "(As per Details)"
                                }
                              </div>
                              <div
                                className="col-1 px-1"
                                style={{
                                  width: "15%",
                                  textAlign: "left",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.voucher_type_name}
                              </div>
                              <div
                                className="col-1 px-1"
                                style={{
                                  width: "12%",
                                  textAlign: "right",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.serial_no && !isNaN(item.serial_no) ? parseInt(item.serial_no, 10) : item?.serial_no}
                              </div>
                              <div
                                className="col-2 px-1"
                                style={{
                                  width: "10%",
                                  textAlign: "right",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.type === "CR" && item?.voucher_amount > 0
                                  ? formatCurrency(item?.voucher_amount)
                                  : item?.voucher_type?.toLowerCase().includes("journal") && item?.particular_ledger_pos?.[1]?.type === "CR" && item?.particular_ledger_pos?.[1]?.particular_ledger_pay_amount > 0
                                    ? formatCurrency(item?.particular_ledger_pos?.[1]?.particular_ledger_pay_amount)
                                    : ''}
                              </div>
                              <div
                                className="col-2 px-1"
                                style={{
                                  width: "10%",
                                  textAlign: "right",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item?.type === "DR" && item?.voucher_amount > 0
                                  ? formatCurrency(item?.voucher_amount)
                                  : item?.voucher_type?.toLowerCase().includes("journal") && item?.particular_ledger_pos?.[1]?.type === "DR" && item?.particular_ledger_pos?.[1]?.particular_ledger_pay_amount > 0
                                    ? formatCurrency(item?.particular_ledger_pos?.[1]?.particular_ledger_pay_amount)
                                    : ''}
                              </div>
                              {state_configure?.formate_of_report === "Detailed"
                                ? item.particular_ledger_pos?.map(
                                  (ledger, ledgerIndex) => (
                                    <>
                                      <div className="col-12" key={ledgerIndex}>
                                        {item?.voucher_type?.toLowerCase().includes("sale") ||
                                          item?.voucher_type?.toLowerCase().includes("purchase") ||
                                          item?.voucher_type?.toLowerCase().includes("debit note") ||
                                          item?.voucher_type?.toLowerCase().includes("credit note") ? (
                                          <div className="row">
                                            <div
                                              className="col-3 offset-2"
                                              style={{ textAlign: "left", fontSize: "13px" }}
                                            >
                                              {ledger?.party_bill_to_ledger_name}
                                            </div>
                                            <div
                                              className="col-2"
                                              style={{ textAlign: "left", fontSize: "13px" }}
                                            >
                                              {`${formatCurrency(item?.party_to_pay_amount)} ${ledger?.voucher_type.toLowerCase().includes("sale") || ledger?.voucher_type.toLowerCase().includes("debit note") ? "Dr" : "Cr"}`}
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="row">
                                            <div
                                              className="col-3 offset-2"
                                              style={{ textAlign: "left", fontSize: "13px" }}
                                            >
                                              {ledger?.particular_ledger_name}
                                            </div>
                                            <div
                                              className="col-2"
                                              style={{ textAlign: "left", fontSize: "13px" }}
                                            >
                                              {`${ledger?.transaction_type ? formatCurrency(
                                                ledger?.particular_ledger_pay_amount > 0 ? ledger?.particular_ledger_pay_amount : ledger?.total_amount
                                              ) : ''} ${ledger?.transaction_type ? ledger?.transaction_type : ''}`}
                                            </div>
                                          </div>
                                        )}
                                        {item?.voucher_type?.toLowerCase().includes("sale") ||
                                          item?.voucher_type?.toLowerCase().includes("purchase") ||
                                          item?.voucher_type?.toLowerCase().includes("debit note") ||
                                          item?.voucher_type?.toLowerCase().includes("credit note") ? (
                                          <>
                                            {/* Stock Items Section */}
                                            {ledgerIndex === 0 && item.voucher_item_data?.length > 0 && item.voucher_item_data.map((vitem, vindex) => (
                                              <div className="row" key={`item-${vindex}`}>
                                                <div className="col-3 offset-2"
                                                  style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {vitem.item_name}
                                                </div>
                                                <div className="col-2" style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {formatCurrency(vitem.item_amt)} {ledger?.voucher_type.toLowerCase().includes("sale") || ledger?.voucher_type.toLowerCase().includes("debit note") ? "Cr" : "Dr"}
                                                </div>
                                              </div>
                                            ))}

                                            {/* Additional Ledgers (Expenses/Taxes) Section */}
                                            {ledgerIndex === 0 && item.sale_purchase_item_ledger?.length > 0 && item.sale_purchase_item_ledger.map((sitem, sindex) => (
                                              <div className="row" key={`sale-item-${sindex}`}>
                                                <div className="col-3 offset-2" style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {sitem.sales_ledger_name}
                                                </div>
                                                <div className="col-2" style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {formatCurrency(sitem.ledger_amt)} {ledger?.voucher_type.toLowerCase().includes("sale") || ledger?.voucher_type.toLowerCase().includes("debit note") ? "Cr" : "Dr"}
                                                </div>
                                              </div>
                                            ))}

                                            {/* Payment Allocation (Bill-wise) Section */}
                                            {ledgerIndex === 0 && item.payment_allocation_data?.length > 0 && item.payment_allocation_data.map((pitem, pindex) => (
                                              <div className="row" key={`pay-item-${pindex}`}>
                                                <div className="col-3 offset-2" style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {pitem.ledger_name}
                                                </div>
                                                <div className="col-2" style={{ textAlign: "left", fontSize: "13px" }}>
                                                  {formatCurrency(pitem.payment_ledger_amount)} {pitem.type}
                                                </div>
                                              </div>
                                            ))}
                                          </>
                                        ) : null}
                                      </div>
                                    </>
                                  ))
                                : null}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="tomasterfooter">
          {show_period || show_other_voucher || show_period_double ? null : (
            <div className="footer">
              <div className="boxfooter">
                <button className="button">Esc: Back</button>
              </div>
              <div className="boxfooter">
                <button className="button" disabled={filteredData.length === 0}>Enter: View</button>
              </div>
              <div className="boxfooter">
                <button className="button" disabled={filteredData.length === 0}><u>Enter</u>: Alter</button>
              </div>
              <div className="boxfooter">
                <button className="button" disabled={filteredData.length === 0}>Space: Select</button>
              </div>
              <div className="boxfooter">
                <button type="submit" className="button"
                  onClick={(e) => {
                    e.preventDefault();
                    const selectedList = filteredData[selectedItem];
                    if (selectedList) {
                      navigate(`../voucherstransaction`, {
                        state: {
                          create_date: dateFormateShow(selectedList?.create_date),
                          voucher_type_id: selectedList?.voucher_type_id,
                          voucher_type_name: selectedList?.voucher_type_name
                        }
                      });
                    } else {
                      navigate(`../voucherstransaction`);
                    }
                  }}
                >
                  <u>A</u>: Add Vch
                </button>
              </div>
              <div className="boxfooter">
                <button
                  className="button"
                  disabled={filteredData.length === 0}
                  onClick={(e) => {
                    e.preventDefault();
                    const selectedList = filteredData[selectedItem];
                    if (selectedList) {
                      navigate(`../voucher-transaction/${selectedList?.uid}`);
                    }
                  }}
                >
                  <u>2</u>: Duplicate Vch
                </button>
              </div>
              <div className="boxfooter">
                <button className="button" disabled={filteredData.length === 0}>
                  <u>I</u>: Insert Vch
                </button>
              </div>
              <div className="boxfooter">
                <button
                  className="button"
                  disabled={filteredData.length === 0 || selectedItems.length === 0}
                  onClick={(e) => {
                    return e.preventDefault(), setIsDeleteModalOpen(true);
                  }}
                >
                  <u>D</u>: Delete
                </button>
              </div>
              <div className="boxfooter">
                <button className="button" disabled={filteredData.length === 0 || selectedItems.length === 0}>
                  <u>X</u>: Cancel
                </button>
              </div>
              <div className="boxfooter">
                <button className="button" onClick={removeSelectedItems} disabled={filteredData.length === 0 || selectedItems.length === 0}>
                  <u>
                    <u>R</u>
                  </u>
                  : Remove Line
                </button>
              </div>
              <div className="boxfooter" onClick={restoreSelectedItems}>
                <button disabled={removedItems.length <= 0} className="button">
                  <u>
                    <u>U</u>
                  </u>{" "}
                  : Restore Line
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="help border_1_1px_left backgroud_color_1 position-relative">
        {show_period || show_other_voucher || show_period_double ? null : (
          <>
            <div className="help_button_card">
              <button
                className={`button_padding`}
                onClick={() => {
                  setState_configure((prev) => ({
                    ...prev,
                    formate_of_report:
                      prev.formate_of_report === "Detailed" ? "Condensed" : "Detailed",
                  }));
                }}
                style={{
                  background: "white",
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginBottom: 2,
                }}
              >
                <p className="card-header">
                  <u>F1</u>: {state_configure.formate_of_report === "Detailed" ? "Condensed" : "Detailed"}
                </p>
              </button>
            </div>
            <div className="help_button_card">
              <button
                className={`button_padding`}
                onClick={() => {
                  return setshow_period(true);
                }}
                style={{
                  background: "white",
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginBottom: 2,
                }}
              >
                <p className="card-header">
                  <span>F2</span>: Date
                </p>
              </button>
            </div>
            <div className="help_button_card">
              <button
                className={`button_padding`}
                onClick={() => {
                  return setshow_period_double(true);
                }}
                style={{
                  background: "white",
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginBottom: 2,
                }}
              >
                <p className="card-header">
                  <span>
                    {" "}
                    <u>F2</u> :
                  </span>
                  Period
                </p>
              </button>
            </div>
            <div className="help_button_card">
              <button
                className={`button_padding`}
                onClick={() => {
                  return setshow_other_voucher(true);
                }}
                style={{
                  background: "white",
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginBottom: 2,
                }}
              >
                <p className="card-header">
                  <span>F4</span>: voucher type
                </p>
              </button>
            </div>
            <div style={{ position: "absolute", bottom: 0, width: "100%" }}>
              <div className="help_button_card mb-2 ms-1">
                <button
                  className={`button_padding`}
                  style={{
                    background: "white",
                    paddingTop: 3,
                    paddingBottom: 3,
                    marginBottom: 2,
                  }}
                >
                  <p className="card-header">
                    <span>F12</span>: Configure
                  </p>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DayBook;

function Period(props) {
  const [date, setdate] = useState({ date_get: props.date || "" });
  const from_input_ref = useRef(null);
  const { company_session } = useSelector((state) => state.common);

  useEffect(() => {
    if (from_input_ref.current) {
      from_input_ref.current.focus();
      from_input_ref.current.select();
    }
  }, []);
  const handlechange = (e) => {
    const { name, value } = e?.target;
    setdate((prevDate) => ({ ...prevDate, [name]: value }));
    if (name === "date_get") {
      if (e?.key === "Enter" && date?.date_get !== "") {
        e?.preventDefault();
        const value = date.date_get.trim();
        const result = getValidPeriodDate(value, company_session);
        if (result) {
          const formattedDateString = result.formattedDateString;
          const formattedDateString_send = dateFormateSend(formattedDateString);

          setdate({ ...date, date_get: formattedDateString });
          props?.setsend_date({
            from_date: formattedDateString_send,
            to_date: "",
          });
          props?.setDate(formattedDateString);
          props.setLoading(true);
          props.setshow_period(false);
        } else {
          alert("Invalid Date");
        }
      }
    }
  };
  useEffect(() => {
    const handlekeydown = (e) => {
      if (e?.key === "Escape") {
        e?.preventDefault();
        props?.setshow_period(false);
        e?.stopPropagation();
      }
    };
    document.addEventListener("keydown", handlekeydown);
    return () => {
      document.removeEventListener("keydown", handlekeydown);
    };
  }, [props?.data, date]);
  const { date_get } = date;
  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          return props.setshow_period(false);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className="container pb-3" id="card-period">
        <div className="row">
          <div className="col">
            <b className="border-bottom">Voucher Date</b>
          </div>
        </div>
        <div className="row">
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <div className="col">
              <div className="d-flex justify-content-between align-item-center">
                <label className="lab-1">Date of Voucher</label>
                <label>:</label>
                <input
                  type="text"
                  autoFocus
                  name="date_get"
                  id="date_get"
                  ref={from_input_ref}
                  onChange={handlechange}
                  onKeyUp={handlechange}
                  value={date_get || ""}
                  onFocus={(e) => e.target.select()}
                  className="lab-right"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}
function PeriodDouble(props) {
  const dispatch = useDispatch();
  const [date, setdate] = useState({
    from: typeof props.date === 'string' ? props.date : (props.date?.from_date || ""),
    to: typeof props.date === 'string' ? props.date : (props.date?.to || ""),
    show_date: props.send_date?.from_date || "",
  });
  const from_input_ref = useRef(null);
  const to_input_ref = useRef(null);
  const { company_session } = useSelector((state) => state.common);

  useEffect(() => {
    setTimeout(() => {
      if (from_input_ref.current) {
        from_input_ref.current.focus();
        from_input_ref.current.select();
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (props?.date && props?.send_date) {
      setdate({
        from: typeof props.date === 'string' ? props.date : (props.date?.from_date || ""),
        to: typeof props.date === 'string' ? props.date : (props.date?.to || ""),
        show_date: props.send_date?.from_date || "",
      });
    }
  }, [props.date, props.send_date]);
  const handlechange = (e) => {
    const { name, value } = e?.target;
    setdate((prevDate) => ({ ...prevDate, [name]: value }));
    if (name === "from") {
      if (e?.key === "Enter") {
        e?.preventDefault();
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.start_financial_year) {
            inputValue = new Date(company_session.start_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        if (inputValue !== '') {
          const result = getValidPeriodDate(inputValue, company_session, company_session?.current_date_1);

          if (result) {
            setdate({
              ...date,
              from: result.formattedDateString,
              show_date: result.formattedDateString,
            });
            to_input_ref.current.focus();
            to_input_ref.current.select();
          } else {
            alert("Invalid Date.");
          }
        }
      }
    }
    if (name === "to") {
      if (e?.key === "Enter" && date?.from !== "") {
        e?.preventDefault();
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.end_financial_year) {
            inputValue = new Date(company_session.end_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        if (inputValue !== '') {
          const result = getValidPeriodDate(inputValue, company_session, date.from);

          if (result) {
            const from_date_check = new Date(date?.show_date);
            const formattedDateString_send = dateFormateSend(result.formattedDateString);

            // Validation: to_date >= from_date
            if (new Date(formattedDateString_send) < from_date_check) {
              alert("To Date cannot be less than From Date");
              return;
            }

            props?.setDate({
              from_date: date?.from,
              to: result.formattedDateString,
            });
            props?.setsend_date({
              from_date: dateFormateSend(date?.from),
              to_date: formattedDateString_send,
            });
            props.setLoading(true);
            props?.setshow_period_double(false);
          } else {
            alert("Invalid Date.");
          }
        }
      }
    }
  };

  useEffect(() => {
    const handlekeydown = (e) => {
      if (e?.key === "Escape") {
        e?.preventDefault();
        props?.setshow_period_double(false);
        e?.stopPropagation();
      }
    };
    document.addEventListener("keydown", handlekeydown);
    return () => {
      document.removeEventListener("keydown", handlekeydown);
    };
  }, [props?.data, date]);
  const { from, to } = date;
  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          return props.setshow_period_double(false);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className="container pb-3" id="card-period">
        <div className="row">
          <div className="col">
            <b className="border-bottom">Change Period</b>
          </div>
        </div>
        <div className="row">
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <div className="col">
              <div className="d-flex justify-content-between align-item-center">
                <label className="lab-1">From Date</label>
                <label>:</label>
                <input
                  type="text"
                  name="from"
                  id="from"
                  ref={from_input_ref}
                  onChange={handlechange}
                  onKeyUp={handlechange}
                  value={from || ""}
                  onFocus={(e) => e.target.select()}
                  className="lab-right"
                />
              </div>
              <div className="d-flex justify-content-between align-item-center">
                <label className="lab-1">To</label>
                <label>:</label>
                <input
                  type="text"
                  name="to"
                  id="to"
                  ref={to_input_ref}
                  onChange={handlechange}
                  onKeyUp={handlechange}
                  value={to || ""}
                  onFocus={(e) => e.target.select()}
                  className="lab-right"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}
function OtherVoucher(props) {
  const [search_input, setSearchInput] = useState("");
  const { voucher_type_data = null } = useSelector((state) => state.common);
  const [selectedItem, setSelectedItem] = useState(0);
  const search_input_ref = useRef(null);
  const list_items_refs = useRef([]);

  const filteredData = useMemo(() => {
    if (!voucher_type_data) return [];
    return Object.keys(voucher_type_data)?.filter((key) =>
      voucher_type_data[key]?.voucher_type_name
        ?.toLowerCase()
        ?.includes(search_input?.toLowerCase())
    );
  }, [voucher_type_data, search_input]);

  const handlechange = (e) => {
    setSearchInput(e.target.value);
    setSelectedItem(0); // Reset selection on search
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "ArrowDown" || e.key === "Enter") {
      e.preventDefault();
      if (filteredData.length > 0) {
        // Move focus to the first selected item in the list
        list_items_refs.current[selectedItem]?.focus();
      }
    }
    // Escape and Enter are handled by the native capture listener below to prevent global navigation leaks
  };

  const handleListKeyDown = (e, index) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = Math.max(index - 1, 0);
      setSelectedItem(prevIndex);
      list_items_refs.current[prevIndex]?.focus();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextIndex = Math.min(index + 1, filteredData.length - 1);
      setSelectedItem(nextIndex);
      list_items_refs.current[nextIndex]?.focus();
    }
    // Escape and Enter are handled by the native capture listener below to prevent global navigation leaks
  };


  useEffect(() => {
    const handleKeyDownGlobal = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        props.setshow_other_voucher(false);
      } else if (e.key === "Enter") {
        // Only intercept Enter if focus is within our component
        if (search_input_ref.current?.contains(document.activeElement) ||
          list_items_refs.current.some(ref => ref?.contains(document.activeElement))) {

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (document.activeElement === search_input_ref.current) {
            if (filteredData.length > 0) {
              list_items_refs.current[selectedItem]?.focus();
            }
          } else {
            const selectedKey = filteredData[selectedItem];
            const selectedLink = voucher_type_data[selectedKey];
            if (selectedLink) {
              props.displayNameOfVoucherType(selectedLink?.voucher_type_name);
            }
          }
        }
      }
    };
    // Use capture: true to intercept the event before Index.js's window listener
    document.addEventListener("keydown", handleKeyDownGlobal, { capture: true });
    return () => {
      document.removeEventListener("keydown", handleKeyDownGlobal, { capture: true });
    };
  }, [props.show_other_voucher, filteredData, selectedItem, voucher_type_data]);




  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          return props.setshow_other_voucher(false);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className="container">
        <div class="row justify-content-center">
          <div className="col-12">
            <div className="row justify-content-center">
              <div class="col-3 border bg-light border-dark">
                <p style={{ textAlign: "center" }}>Change Voucher Type</p>
                <input
                  autoFocus
                  className="masterInput"
                  type="text"
                  id="search_input"
                  name="search_input"
                  placeholder="Enter Here......"
                  onChange={handlechange}
                  onKeyDown={handleInputKeyDown}
                  ref={search_input_ref}
                  value={search_input || ""}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row justify-content-center">
              <div
                class="col-4 border bg-light border-dark"
                style={{ height: "70vh", overflowY: "scroll" }}
              >
                <div className="row background" style={{ height: 20 }}>
                  List of voucher type
                </div>
                <div className="row">
                  {filteredData.length > 0 ? (
                    filteredData.map((key, number) => {
                      const name = voucher_type_data[key]?.voucher_type_name;
                      const index = name
                        ?.toLowerCase()
                        ?.indexOf(search_input?.toLowerCase());
                      return (
                        <div
                          className={` col-12 list dropdown_link ${number === selectedItem ? "selected" : ""
                            }`}
                          key={number}
                          tabIndex={0}
                          ref={(el) => (list_items_refs.current[number] = el)}
                          onKeyDown={(e) => handleListKeyDown(e, number)}
                          onFocus={() => setSelectedItem(number)}
                          onClick={(e) => {
                            e.preventDefault();
                            props.displayNameOfVoucherType(name);
                          }}
                        >
                          <Link to="#" onClick={(e) => e.preventDefault()}>
                            {index !== -1 ? (
                              <>
                                {name?.substring(0, index)}
                                <span style={{ color: "red" }}>
                                  {name?.substring(
                                    index,
                                    index + search_input.length
                                  )}
                                </span>
                                {name?.substring(index + search_input.length)}
                              </>
                            ) : (
                              name
                            )}
                          </Link>
                        </div>
                      );
                    })
                  ) : (
                    <p style={{ color: "red" }}>No matching items found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}

function Configure(props) {
  const [state, setState] = useState({
    show_narrations: "No",
    formate_of_report: "Condensed",
    show_bill_wise_details: "No",
    show_inventory_details: "No",
    show_mode_of_payment: "No",
    show_additional_bank_details: "No",
    display_name_for_ledgers: "Name Only",
    display_name_for_stock_items: "Name Only",
    sorting_method: "Default",
    show_running_balance: "Yes",
  });
  const show_narrations_input_ref = useRef(null);
  const formate_of_report_input_ref = useRef(null);
  const show_bill_wise_details_input_ref = useRef(null);
  const show_inventory_details_input_ref = useRef(null);
  const show_mode_of_payment_input_ref = useRef(null);
  const show_additional_bank_details_input_ref = useRef(null);
  const display_name_for_ledgers_input_ref = useRef(null);
  const display_name_for_stock_items_input_ref = useRef(null);
  const sorting_method_input_ref = useRef(null);
  const show_running_balance_input_ref = useRef(null);

  const handlechange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
    // space key functionality
    if (e.code == "Space") {
      e.preventDefault();
      const cursorPosition_start = e.target.selectionStart;
      if (cursorPosition_start == 1) {
        setState({ ...state, [name]: "" });
        return;
      }
    }
    // Enter key functionality
    if (e.key === "Enter") {
      e.preventDefault();
      const nextInputRef =
        name === "show_narrations"
          ? formate_of_report_input_ref
          : name === "formate_of_report"
            ? show_bill_wise_details_input_ref
            : name === "show_bill_wise_details"
              ? show_inventory_details_input_ref
              : name === "show_inventory_details"
                ? show_mode_of_payment_input_ref
                : name === "show_mode_of_payment"
                  ? show_additional_bank_details_input_ref
                  : name === "show_additional_bank_details"
                    ? display_name_for_ledgers_input_ref
                    : name === "display_name_for_ledgers"
                      ? display_name_for_stock_items_input_ref
                      : name === "display_name_for_stock_items"
                        ? sorting_method_input_ref
                        : name === "sorting_method"
                          ? show_running_balance_input_ref
                          : null;
      if (name === "show_running_balance") {
        if (e.key === "Enter") {
          e.preventDefault();
          props.setState_configure({
            show_narrations: state?.show_narrations,
            formate_of_report: state?.formate_of_report,
            show_bill_wise_details: state?.show_bill_wise_details,
            show_inventory_details: state?.show_inventory_details,
            show_mode_of_payment: state?.show_mode_of_payment,
            show_additional_bank_details: state?.show_additional_bank_details,
            display_name_for_ledgers: state?.display_name_for_ledgers,
            display_name_for_stock_items: state?.display_name_for_stock_items,
            sorting_method: state?.sorting_method,
            show_running_balance: state?.show_running_balance,
          });
          if (typeof props.setshow_configure === 'function') {
            props.setshow_configure(false);
          }
        }
      }
      if (nextInputRef) {
        nextInputRef.current.focus();
        if (nextInputRef.current) {
          nextInputRef.current.setSelectionRange(
            0,
            nextInputRef?.current?.value?.length
          );
        }
      }
      return;
    }
    // Back space key functionality
    if (e.key === "Backspace") {
      e.preventDefault();
      const prevInputRef =
        name === "formate_of_report"
          ? show_narrations_input_ref
          : name === "show_bill_wise_details"
            ? formate_of_report_input_ref
            : name === "show_inventory_details"
              ? show_bill_wise_details_input_ref
              : name === "show_mode_of_payment"
                ? show_inventory_details_input_ref
                : name === "show_additional_bank_details"
                  ? show_mode_of_payment_input_ref
                  : name === "display_name_for_ledgers"
                    ? show_additional_bank_details_input_ref
                    : name === "display_name_for_stock_items"
                      ? display_name_for_ledgers_input_ref
                      : name === "sorting_method"
                        ? display_name_for_stock_items_input_ref
                        : name === "show_running_balance"
                          ? sorting_method_input_ref
                          : null;
      const cursorPosition = e.target.selectionStart;
      if (cursorPosition === 0) {
        prevInputRef.current.focus();
        if (prevInputRef.current) {
          prevInputRef.current.setSelectionRange(0, 0);
        }
      }
      return;
    }
  };
  const {
    show_narrations,
    formate_of_report,
    show_bill_wise_details,
    show_inventory_details,
    show_mode_of_payment,
    show_additional_bank_details,
    display_name_for_ledgers,
    display_name_for_stock_items,
    sorting_method,
    show_running_balance,
  } = state;
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        if (typeof props.setshow_configure === 'function') {
          props.setshow_configure(false);
        }
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.show_configure]);
  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          if (typeof props.setshow_configure === 'function') {
            props.setshow_configure(false);
          }
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div
        className="container pb-3 border border-dark"
        id="card-period"
        style={{ width: "60%", background: "#fff" }}
      >
        <div className="row">
          <div className="col border-bottom">
            <b>Configure</b>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="m-0 p-0 mb-1 border-bottom border-gray">
              General Details
            </p>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Narration</label>
              <label>:</label>
              <input
                type="text"
                autoFocus
                name="show_narrations"
                id="show_narrations"
                ref={show_narrations_input_ref}
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_narrations || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Formate of Report</label>
              <label>:</label>
              <input
                type="text"
                name="formate_of_report"
                ref={formate_of_report_input_ref}
                id="formate_of_report"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={formate_of_report || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Bill Wise Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_bill_wise_details"
                id="show_bill_wise_details"
                ref={show_bill_wise_details_input_ref}
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_bill_wise_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Inventory Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_inventory_details"
                ref={show_inventory_details_input_ref}
                id="show_inventory_details"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_inventory_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Mode of Payment</label>
              <label>:</label>
              <input
                type="text"
                name="show_mode_of_payment"
                ref={show_mode_of_payment_input_ref}
                id="show_mode_of_payment"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_mode_of_payment || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Additional Bank Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_additional_bank_details"
                ref={show_additional_bank_details_input_ref}
                id="show_additional_bank_details"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_additional_bank_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Display Name For Ledgers</label>
              <label>:</label>
              <input
                type="text"
                name="display_name_for_ledgers"
                ref={display_name_for_ledgers_input_ref}
                id="display_name_for_ledgers"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={display_name_for_ledgers || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Display name for stock items</label>
              <label>:</label>
              <input
                type="text"
                name="display_name_for_stock_items"
                ref={display_name_for_stock_items_input_ref}
                id="display_name_for_stock_items"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={display_name_for_stock_items || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Sorting Method</label>
              <label>:</label>
              <input
                type="text"
                name="sorting_method"
                ref={sorting_method_input_ref}
                id="sorting_method"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={sorting_method || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Running Balance</label>
              <label>:</label>
              <input
                type="text"
                name="show_running_balance"
                ref={show_running_balance_input_ref}
                id="show_running_balance"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_running_balance || ""}
                className="lab-right"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}
